import styled from 'styled-components';

export const UserStatistics = styled.div`
  background: var(--bonus-code-modal-bg);
  height: calc(100% - 5.37rem);
  overflow-y: auto;
  padding: 1.25rem;
`;
